import { configureStore } from "@reduxjs/toolkit";

import mapReducer from "./Slices/mapSlice";
import userReducer from "./Slices/userSlice"
import { locationsApi } from "./Services/locationApi";

export const store = configureStore({
  reducer: {
    getMapMode: mapReducer,
    getUserInfo: userReducer,
    [locationsApi.reducerPath]: locationsApi.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(locationsApi.middleware)
});
